module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp13_7042.95415257.png";